module.exports = __webpack_public_path__ + "static/fonts/iconfont.4ea42e9.woff";